import { useEffect, useState } from "react";
import AdminLayout from "../../../src/component/admin/AdminLayout";
import { Link, useLocation } from "react-router-dom";

import {
  getRetreats,
  deleteRetreat,
} from "../../services/retreatService";
export default function Retreats() {
  const [retreats, setRetreats] = useState([]);

  const location = useLocation();

  const filter =
    new URLSearchParams(
      location.search
    ).get("filter") || "all";

useEffect(() => {
  loadRetreats();
}, []);

const loadRetreats = async () => {
  try {
    const res = await getRetreats();
    setRetreats(res.data);
  } catch (err) {
    console.error(err);
  }
};

const handleDelete = async (id) => {
  try {
    await deleteRetreat(id);

    setRetreats((prev) =>
      prev.filter((retreat) => retreat.id !== id)
    );
  } catch (err) {
    console.error(err);
    alert("Failed to delete retreat");
  }
};

  const filteredRetreats =
    filter === "all"
      ? retreats
      : retreats.filter(
          (retreat) =>
            retreat.status?.toLowerCase() ===
            filter.toLowerCase()
        );

  return (
    <AdminLayout>
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-4xl font-bold">
            {filter === "all"
              ? "All Retreat Events"
              : filter === "published"
              ? "Published Retreat Events"
              : "Draft Retreat Events"}
          </h1>

          <p className="text-gray-500 mt-1">
            Total Events: {filteredRetreats.length}
          </p>
        </div>

        <Link
          to="/admin/retreats/new"
          className="bg-secondary text-white px-5 py-3 rounded-xl"
        >
          + Add Event
        </Link>
      </div>

<div className="bg-white rounded-xl shadow overflow-hidden">
  <table className="w-full">
    <thead>
      <tr className="border-b bg-gray-50">
        <th className="p-4 text-left">
          Retreat Type
        </th>

        <th className="p-4 text-left">
          Retreat Title
        </th>

        <th className="p-4 text-left">
          Status
        </th>

        <th className="p-4 text-left">
          Start Date
        </th>

        <th className="p-4 text-left">
          End Date
        </th>

        <th className="p-4 text-left">
          Location
        </th>

        <th className="p-4 text-left">
          Starting Price
        </th>

        <th className="p-4 text-left">
          Actions
        </th>
      </tr>
    </thead>

    <tbody>
      {filteredRetreats.length === 0 ? (
        <tr>
          <td
            colSpan="8"
            className="p-8 text-center text-gray-500"
          >
            No retreat events found
          </td>
        </tr>
      ) : (
        filteredRetreats.map((retreat) => (
          <tr
            key={retreat.id}
            className="border-b hover:bg-gray-50"
          >
<td className="p-4 font-medium">
  {retreat.retreatType?.typeName?.toUpperCase()}
</td>
            <td className="p-4">
              {retreat.retreatTitle}
            </td>

            <td className="p-4">
              <span
                className={`px-3 py-1 rounded-full text-sm ${
                  retreat.status === "published"
                    ? "bg-green-100 text-green-700"
                    : "bg-yellow-100 text-yellow-700"
                }`}
              >
                {retreat.status}
              </span>
            </td>

            <td className="p-4">
              {retreat.startDate}
            </td>

            <td className="p-4">
              {retreat.endDate}
            </td>

            <td className="p-4">
              {retreat.location}
            </td>

            <td className="p-4">
              <span className="font-semibold text-secondary">
                ₹{retreat.startingPrice || "0"}
              </span>
            </td>

            <td className="p-4 flex gap-4">
              <Link
                to={`/admin/retreats/edit/${retreat.id}`}
                className="text-green-600 hover:underline"
              >
                Edit
              </Link>

              <button
                onClick={() => {
                  const confirmDelete =
                    window.confirm(
                      "Delete this retreat?"
                    );

                  if (confirmDelete) {
                    handleDelete(retreat.id);
                  }
                }}
                className="text-red-600 hover:underline"
              >
                Delete
              </button>
            </td>
          </tr>
        ))
      )}
    </tbody>
  </table>
</div>
    </AdminLayout>
  );
}